import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { Button } from "../../ui/button";
import { Label } from "../../ui/label";
import { Switch } from "../../ui/switch";
import env from "../../../config/env";

type Props = {
  clientSecret: string;
  billingAddress?: {
    line1: string;
    city: string;
    state: string;
    postal_code: string;
  };
};

const CardDetails = (props: Props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState<string | null | undefined>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [saveCustomer, setSaveCustomer] = useState<boolean>(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = props.clientSecret;

    if (!clientSecret) {
      return;
    }
    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      console.log("Checking stripe");
      console.log(paymentIntent);
      switch (paymentIntent?.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("");
          break;
        default:
          setMessage("");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const confirmParams: any = {
      return_url: `${env.baseUrl}/customer/payment/success`,
      setup_future_usage: saveCustomer ? "off_session" : undefined,
    };

    // Add billing address if provided
    if (props.billingAddress && props.billingAddress.line1) {
      confirmParams.payment_method_data = {
        billing_details: {
          address: {
            line1: props.billingAddress.line1,
            city: props.billingAddress.city,
            state: props.billingAddress.state,
            postal_code: props.billingAddress.postal_code,
            country: "AU", // Australia
          },
        },
      };
    }

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams,
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
      } else {
        setMessage("An unexpected error occurred.");
      }
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs",
  };
  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" options={{ layout: "tabs" }} />
      {/* <div className="flex flex-row w-full gap-x-4 py-4">
        <div className="flex items-center space-x-2">
          <Switch
            onCheckedChange={(e) => setSaveCustomer(e)}
            id="airplane-mode"
          />
          <Label htmlFor="airplane-mode">Save Card Details</Label>
        </div>
      </div> */}
      <Button
        disabled={isLoading || !stripe || !elements}
        id="submit"
        className="w-full"
      >
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </Button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
};

export default CardDetails;
